import React from 'react'
import AboutHeroSection from '../AboutUsPage/AboutHeroSection'
import AllBlogs from './HomeProsBlogs'

const BlogsPage = () => {
  return (
    <div>
                <AboutHeroSection pageName={"Blogs"}/>
                <AllBlogs/>
    
    </div>
  )
}

export default BlogsPage